// Shared map dimensions and zoom defaults. Imported by MapView for the
// Leaflet bootstrap, by MapImageOverlay for the image overlay bounds, and
// by ScaledMarkerLayer for the painter's-algorithm z-index cap. Keep
// `width`/`height` in sync with the source raster (see
// scripts/optimize-map-image.mjs).
export const MAP_CONFIG = {
  width: 2000,
  height: 3100,
  minZoom: -3,
  maxZoom: 3,
  defaultZoomDesktop: -0.3,
  defaultZoomMobile: -1,
  // Fallback pan centre in [lat, lng] pixel coords (CRS.Simple: lat = Y, lng = X).
  // Used while data is loading (or if no positions exist); once positions
  // arrive, MapView fits the view to their bounding box (issue #218).
  defaultCenter: [1500, 800] as [number, number],
  // Zoom ceiling for the initial fitBounds — keeps a lone (or tightly
  // clustered) set of positions from zooming in past a useful overview.
  initialFitMaxZoom: 0,
};
